import { Input, Table } from 'antd';
import styled from 'styled-components';

export const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const SearchControls = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ReturnsTable = styled(Table)`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 10px;
  }

  .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
  }
`;

export const StatusTag = styled.div`
  background: ${(props) => props.$background || 'transparent'};
  padding: 4px 8px;
  border-radius: 4px;
`;

export const SearchInput = styled(Input)`
  width: 320px;
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.white};
  height: 100vh;
  padding: 75px 20px 0 250px;
  overflow: auto;

  a {
    text-decoration: none;
    color: #c12;
  }

  @media only screen and (max-width: 1024px) {
    padding: 70px 10px;
    display: block;
    width: 100%;
  }
`;
